import { Transition, Variants } from 'framer-motion';

export const transition: Transition = {
  x: {
    type: 'spring',
    damping: 25,
    stiffness: 500,
    duration: 0.25,
  },
};

export const chipVariants: Variants = {
  open: {
    x: 0,
    opacity: 1,
    transition,
  },
  closed: {
    x: 20,
    opacity: 0,
    transition,
  },
  exit: {
    x: -20,
    opacity: 0,
    transition,
  },
};
